export const ProductsResource = {
  name: "Products",
  path: "/inventory/products",
  access: ["read-products"],
};
